import React from "react";
import TrackInfoTool from "../../../components/tools/TrackInfoTool";
import { TutorialJourneysList } from "../../../components/admin/journey/TutorialJourneysList";

export function AdminJourneyTemplates() {
  return (
    <>
      <TutorialJourneysList />
      <TrackInfoTool
        trackInfo={{
          name: "Admin - Journey Template",
        }}
      />
    </>
  );
}
